<eds-staggered-content
  [preTitle]="content?.preTitle"
  [title]="content?.title"
  [summary]="content?.summary"
  [cards]="content?.cards && content?.cards.length > 0 ? content?.cards : null"
  [href]="link"
  [signInRequired]="content?.link?.signInLink | ftIsSignInRequired | async"
  [hideLockIcon]="content?.link?.hideLockIcon"
  [btnType]="'primary'"
  [btnLabel]="content?.link?.displayText"
  [isNewWindow]="content?.link?.target"
  [externalLink]="content?.link?.external"
  [theme]="theme && theme !== 'grey' ? theme : 'primary'"
  [titleTheme]="titleTheme"
  [signInTooltip]="'common.locked-link-tooltip' | translate"
></eds-staggered-content>

<!-- identify why links are not showing on staggered cards -->
